import styled, { css } from 'styled-components'

const designerCSS = css`
  display: flex;
  position: relative;
  margin: 0 0 0 25px;
  gap: 5px;

  @media (max-width: 800px) {
    display: none;
  }
`

const developerCSS = css``

export const TopLeftNav = styled.div`
  ${designerCSS}
  ${developerCSS}
`
